import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    initials: 'MR',
    quote: 'Organicé mis protocolos clínicos en una tarde. Ahora abordo patologías complejas con un camino claro y seguro.',
    name: 'Martina R.',
    location: 'Buenos Aires',
    role: 'Nutricionista Clínica'
  }, {
    initials: 'JC',
    quote: "El abordaje de síndrome metabólico es oro. Me da un protocolo claro y me evita 'probar cosas' al azar con pacientes de riesgo.",
    name: 'Juan C.',
    location: 'Rosario',
    role: 'Nutricionista Clínico'
  }, {
    initials: 'SV',
    quote: 'Antes perdía horas buscando papers para cada patología. Ahora tengo la evidencia resumida y lista para aplicar en consulta.',
    name: 'Sofía V.',
    location: 'Córdoba',
    role: 'Nutricionista (clínica/deportiva)'
  }];
  return <section className="pt-5 pb-8 px-3 max-w-6xl mx-auto" data-id="element-277">
      <div data-id="element-278">
        <h2 className="text-center font-display text-2xl md:text-3xl font-bold text-accent mb-5" data-id="element-279">
          Lo que dicen los nutricionistas que ya lo usan
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-3" data-id="element-280">
        {testimonials.map((t, idx) => <div key={idx} className="p-3 relative" data-id="element-281">
            <div className="bg-accent text-black w-8 h-8 rounded-full flex items-center justify-center font-bold text-xs shadow-md mb-2" data-id="element-282">
              {t.initials}
            </div>
            <div className="flex gap-0.5 mb-1.5" data-id="element-283">
              {[...Array(5)].map((_, i) => <Star key={i} size={11} className="fill-accent text-accent" data-id="element-284" />)}
            </div>
            <p className="text-white/80 italic mb-2 leading-relaxed text-xs" data-id="element-285">
              "{t.quote}"
            </p>
            <div className="border-t border-white/10 pt-2" data-id="element-286">
              <p className="font-bold text-accent text-xs" data-id="element-287">{t.name}</p>
              <p className="text-[11px] text-white/50" data-id="element-288">
                {t.location} | {t.role}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}